import { Col, Container, Row } from 'reactstrap'
import LoginForm from '../Common/LoginForm'

const LoginWithImageTwoContainer = () => {
  return (
    <Container fluid>
      <Row>
        <Col xl="5" className='loginImageBg3' ></Col>
        <Col xl="7" className="p-0">
          <LoginForm />
        </Col>
      </Row>
    </Container>
  )
}

export default LoginWithImageTwoContainer